<template>
  <button
    class="city-item"
    :class="{ selected: isSelected }"
    type="button"
    :aria-pressed="isSelected"
    @click="toggleSelection"
  >
    <img
      :src="RegionService.getFlagUrl(city.region_id)"
      :alt="city.region_name || 'Флаг региона'"
      class="flag-icon"
    />

    <span class="city-text">
      <span class="city-name">
        {{ city.city }}
      </span>

      <span
        v-if="city.region_name"
        class="city-region"
      >
        {{ city.region_name }}
      </span>
    </span>

    <span
      class="selection-indicator"
      :class="{ visible: isSelected }"
      aria-hidden="true"
    >
      <img
        v-if="isSelected"
        src="/success.png"
        alt=""
        class="success-icon"
      />
    </span>
  </button>
</template>

<script setup>
import { computed } from "vue";
import RegionService from "../utils/RegionService";

const props = defineProps({
  city: {
    type: Object,
    required: true
  },

  selectedCityId: {
    type: String,
    default: null
  }
});

const emit = defineEmits([
  "select-city"
]);

const isSelected = computed(() => {
  return props.city?._id === props.selectedCityId;
});

const toggleSelection = () => {
  emit("select-city", props.city);
};
</script>

<style scoped>
.city-item {
  width: 100%;
  min-width: 0;
  min-height: 44px;

  display: flex;
  align-items: center;
  gap: 10px;

  box-sizing: border-box;
  padding: 9px 11px;

  border: 1px solid transparent;
  border-radius: 10px;

  background: transparent;

  color: var(--city-item-text);

  font-family: "Eastman-Medium", sans-serif;
  text-align: left;

  cursor: pointer;

  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    transform 0.18s ease;
}

.city-item:hover {
  background: var(--city-item-hover-bg);
  border-color: var(--city-item-hover-border);
  color: var(--city-item-hover-text);
}

.city-item:active {
  transform: scale(0.995);
}

.city-item.selected {
  background: #2887f7;
  border-color: #2887f7;
  color: #ffffff;

  box-shadow:
    0 4px 12px
    rgba(40, 135, 247, 0.22);
}

/* Флаг */

.flag-icon {
  width: 22px;
  height: 16px;
  flex-shrink: 0;

  object-fit: cover;

  border-radius: 3px;

  box-shadow:
    0 1px 4px
    rgba(0, 0, 0, 0.14);
}

/* Текст */

.city-text {
  min-width: 0;
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 2px;
}

.city-name {
  overflow: hidden;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 13px;
  line-height: 1.25;

  white-space: nowrap;
  text-overflow: ellipsis;
}

.city-region {
  overflow: hidden;

  color: var(--city-item-region-text);

  font-family: "Eastman-Regular", sans-serif;
  font-size: 10px;
  line-height: 1.2;

  white-space: nowrap;
  text-overflow: ellipsis;

  transition: color 0.18s ease;
}

.city-item.selected .city-region {
  color: rgba(255, 255, 255, 0.72);
}

/* Галочка */

.selection-indicator {
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 0;

  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}

.selection-indicator.visible {
  opacity: 1;
  transform: scale(1);
}

.success-icon {
  width: 18px;
  height: 18px;

  object-fit: contain;
}

/* Keyboard focus */

.city-item:focus-visible {
  outline: none;

  box-shadow:
    0 0 0 3px
    rgba(40, 135, 247, 0.2);
}

/* Theme */

:global(:root) {
  --city-item-text:
    #c5c5c5;

  --city-item-region-text:
    rgba(255, 255, 255, 0.42);

  --city-item-hover-bg:
    rgba(255, 255, 255, 0.07);

  --city-item-hover-border:
    rgba(255, 255, 255, 0.08);

  --city-item-hover-text:
    #ffffff;
}

:global([data-theme="light"]) {
  --city-item-text:
    var(--header-text-light);

  --city-item-region-text:
    rgba(31, 31, 31, 0.46);

  --city-item-hover-bg:
    rgba(40, 135, 247, 0.07);

  --city-item-hover-border:
    rgba(40, 135, 247, 0.14);

  --city-item-hover-text:
    #1f1f1f;
}

@media (max-width: 768px) {
  .city-item {
    min-height: 42px;
    padding: 8px 10px;
  }

  .city-name {
    font-size: 12px;
  }

  .flag-icon {
    width: 20px;
    height: 15px;
  }
}
</style>